"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { threeSixtyLogo } from "../../../../public/images/logos";
import { roomExample } from "../../../../public/images/three-sixty";
import StepContainer from "./StepContainer";

const Step = () => {
  const t = useTranslations("threeSixtySteps");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col justify-center gap-10">
        <FeatureHighlight
          src={threeSixtyLogo}
          alt={"360-Grad-Rundgang Icon der Grundriss Schmiede"}
          title={t("intro.title")}
          text={t("intro.text")}
        />

        <StepContainer
          title={t("steps.step1.title")}
          text={t("steps.step1.text")}
          src={roomExample}
          alt={"Wohnzimmer Beispiel für 360-Grad-Rundgang"}
          imageFit="cover"
          width={470}
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 200vw, 200vw"
        />
      </div>
    </div>
  );
};

export default Step;
